import { render, staticRenderFns } from "./GlobalAlerts.vue?vue&type=template&id=2d41dfe1&"
import script from "./GlobalAlerts.vue?vue&type=script&lang=js&"
export * from "./GlobalAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports